import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ComplianceMode = 'INFORMATIONAL' | 'ADVERTISING';

export interface AttorneyDisclosure {
  attorney_name: string;
  firm_name: string;
  office_city: string;
  office_county: string;
  fee_disclosure: string;
  bar_number: string | null;
  is_placeholder: boolean;
}

interface ComplianceState {
  mode: ComplianceMode;
  attorneyDisclosure: AttorneyDisclosure | null;
  loading: boolean;
  winningCampaignId: string | null;
}

const initialState: ComplianceState = {
  mode: 'INFORMATIONAL',
  attorneyDisclosure: null,
  loading: false,
  winningCampaignId: null,
};

const complianceSlice = createSlice({
  name: 'compliance',
  initialState,
  reducers: {
    setComplianceMode: (state, action: PayloadAction<ComplianceMode>) => {
      state.mode = action.payload;
    },
    setAttorneyDisclosure: (state, action: PayloadAction<AttorneyDisclosure | null>) => {
      state.attorneyDisclosure = action.payload;
    },
    setWinningCampaignId: (state, action: PayloadAction<string | null>) => {
      state.winningCampaignId = action.payload;
    },
    setComplianceLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    resetCompliance: (state) => {
      state.mode = 'INFORMATIONAL';
      state.attorneyDisclosure = null;
      state.winningCampaignId = null;
    },
  },
});

export const {
  setComplianceMode,
  setAttorneyDisclosure,
  setWinningCampaignId,
  setComplianceLoading,
  resetCompliance,
} = complianceSlice.actions;

export default complianceSlice.reducer;
